import { render, staticRenderFns } from "./SchemaLayout.vue?vue&type=template&id=0ddf5e9f&scoped=true&"
import script from "./SchemaLayout.vue?vue&type=script&lang=js&"
export * from "./SchemaLayout.vue?vue&type=script&lang=js&"
import style0 from "./SchemaLayout.vue?vue&type=style&index=0&id=0ddf5e9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddf5e9f",
  null
  
)

export default component.exports